import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiX, FiCheckCircle } = FiIcons;

const Problem = () => {
  return (
    <section className="py-24 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="bg-white border-l-8 border-red-500 p-10 rounded-2xl max-w-4xl mx-auto shadow-lg mb-12">
            <div className="flex flex-col md:flex-row items-center justify-center mb-4">
              <div className="bg-red-100 p-4 rounded-full mb-4 md:mb-0 md:mr-6">
                <SafeIcon icon={FiX} className="w-10 h-10 text-red-600" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#0e1a30] text-left">
                Você provavelmente já tentou diversas "técnicas" com seu filho e não teve resultados.
              </h3>
            </div>
          </div>
          
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0e1a30] mb-8 leading-tight uppercase">
            E VOCÊ NÃO PRECISA MAIS <br /> PASSAR POR ISSO.
          </h2>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="max-w-5xl mx-auto"
        >
          <div className="bg-[#0e1a30] rounded-3xl p-10 md:p-14 shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-[#29ff89] opacity-10 rounded-full blur-3xl"></div>
            
            <div className="flex flex-col md:flex-row items-start mb-8 relative z-10">
              <div className="bg-[#29ff89] p-3 rounded-full mr-6 mb-4 md:mb-0 shrink-0">
                <SafeIcon icon={FiCheckCircle} className="w-8 h-8 text-[#0e1a30]" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white leading-tight">
                O SEMENTINHA é um método que combina conteúdos, abordagens e estratégias com respaldo científico, validados na Psicologia, com a experiência prática adquirida no acompanhamento de famílias.
              </h3>
            </div>

            <div className="pl-0 md:pl-20 relative z-10">
              <p className="text-lg text-gray-300 leading-relaxed mb-8 font-medium">
                Pais e Mães validaram o método e afirmam que depois de várias tentativas de lidar com seus filhos o que realmente funcionou na prática foram as técnicas que ensino nesse curso.
              </p>
              
              <div className="bg-white/10 p-8 rounded-xl border border-white/10">
                <p className="text-xl font-semibold text-white leading-relaxed">
                  Aqui você vai aprender um conjunto de práticas que realmente funcionam para <span className="text-[#29ff89] font-bold uppercase">EDUCAR SEU FILHO</span>
                  <span className="text-[#29ff89] font-bold">,</span> <span className="text-[#29ff89] font-bold uppercase">AJUDÁ-LO A SE DESENVOLVER EMOCIONALMENTE</span> <span className="text-[#29ff89] font-bold">E</span> <span className="text-[#29ff89] font-bold uppercase">GARANTIR O CUIDADO QUE ELE MERECE</span>
                  <span className="text-[#29ff89] font-bold">.</span>
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <a 
              href="https://pay.kiwify.com.br/IotGhts" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-[#29ff89] text-[#0e1a30] px-12 py-5 rounded-full text-xl font-bold hover:bg-[#20cc6d] transition-all transform hover:scale-105 shadow-xl border-2 border-[#0e1a30]"
            >
              QUERO RESOLVER ISSO AGORA
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Problem;